import { render, staticRenderFns } from "./TheOddsApi.vue?vue&type=template&id=bea4eda8&"
import script from "./TheOddsApi.vue?vue&type=script&lang=js&"
export * from "./TheOddsApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports